module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _SingleSelect = __webpack_require__(2);
    Object.defineProperty(exports, "default", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_SingleSelect).default;
        }
    });
    var _StatelessSelect = __webpack_require__(8);
    Object.defineProperty(exports, "StatelessSelect", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_StatelessSelect).default;
        }
    });
}, /* 2 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(4), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(5), _inherits3 = _interopRequireDefault(_inherits2), _propTypes = __webpack_require__(6), _propTypes2 = _interopRequireDefault(_propTypes), _react = __webpack_require__(7), _react2 = _interopRequireDefault(_react), _StatelessSelect = __webpack_require__(8), _StatelessSelect2 = _interopRequireDefault(_StatelessSelect), _DummyItem = __webpack_require__(21), _DummyItem2 = _interopRequireDefault(_DummyItem), _DummyGroup = __webpack_require__(22), _DummyGroup2 = _interopRequireDefault(_DummyGroup), itemShape = _DummyItem2.default.propTypes, groupShape = _DummyGroup2.default.propTypes, appearances = {
        values: [ "default", "subtle" ],
        default: "default"
    }, AkSingleSelect = function(_PureComponent) {
        function AkSingleSelect() {
            var _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, AkSingleSelect);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, _PureComponent.call.apply(_PureComponent, [ this ].concat(args))), 
            _this.state = {
                isOpen: _this.props.isDefaultOpen,
                selectedItem: _this.props.defaultSelected,
                filterValue: _this.props.defaultSelected ? _this.props.defaultSelected.content : ""
            }, _this.selectItem = function(item) {
                _this.setState({
                    isOpen: !1,
                    selectedItem: item
                }), _this.props.onSelected({
                    item: item
                });
            }, _this.handleOpenChange = function(attrs) {
                _this.setState({
                    isOpen: attrs.isOpen
                }), _this.props.onOpenChange(attrs);
            }, _this.handleFilterChange = function(value) {
                _this.props.onFilterChange(value), _this.setState({
                    filterValue: value
                });
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(AkSingleSelect, _PureComponent), AkSingleSelect.prototype.render = function() {
            return _react2.default.createElement(_StatelessSelect2.default, {
                appearance: this.props.appearance,
                droplistShouldFitContainer: this.props.droplistShouldFitContainer,
                filterValue: this.state.filterValue,
                hasAutocomplete: this.props.hasAutocomplete,
                id: this.props.id,
                isDisabled: this.props.isDisabled,
                isFirstChild: this.props.isFirstChild,
                isInvalid: this.props.isInvalid,
                invalidMessage: this.props.invalidMessage,
                isOpen: this.state.isOpen,
                isRequired: this.props.isRequired,
                items: this.props.items,
                label: this.props.label,
                name: this.props.name,
                noMatchesFound: this.props.noMatchesFound,
                onFilterChange: this.handleFilterChange,
                onOpenChange: this.handleOpenChange,
                onSelected: this.selectItem,
                placeholder: this.props.placeholder,
                position: this.props.position,
                selectedItem: this.state.selectedItem,
                shouldFitContainer: this.props.shouldFitContainer,
                shouldFocus: this.props.shouldFocus,
                shouldFlip: this.props.shouldFlip,
                maxHeight: this.props.maxHeight
            });
        }, AkSingleSelect;
    }(_react.PureComponent);
    AkSingleSelect.propTypes = {
        /** Subtle items do not have a background color. */
        appearance: _propTypes2.default.oneOf(appearances.values),
        /** Item to be selected on component mount. */
        defaultSelected: _propTypes2.default.shape(itemShape),
        /** Sets whether the dropdown should be constrained to the width of its trigger */
        droplistShouldFitContainer: _propTypes2.default.bool,
        /** Sets whether the field should be selectable. If it is, the field will be
	  a text box, which will filter the items. */
        hasAutocomplete: _propTypes2.default.bool,
        /** id property to be passed down to the html select component. */
        id: _propTypes2.default.string,
        /** message to show on the dialog when isInvalid is true */
        invalidMessage: _propTypes2.default.node,
        /** controls the top margin of the label component rendered. */
        isFirstChild: _propTypes2.default.bool,
        /** Sets whether the select is selectable. Changes hover state. */
        isDisabled: _propTypes2.default.bool,
        /** Sets whether the component should be open on mount. */
        isDefaultOpen: _propTypes2.default.bool,
        /** Sets whether form including select can be submitted without an option
	  being made. */
        isRequired: _propTypes2.default.bool,
        /** Set whether there is an error with the selection. Sets an orange border
	  and shows the warning icon. */
        isInvalid: _propTypes2.default.bool,
        /** An array of objects, each one of which must have an array of items, and
	  may have a heading. All items should have content and value properties, with
	  content being the displayed text. */
        items: _propTypes2.default.arrayOf(_propTypes2.default.shape(groupShape)),
        /** Label to be displayed above select. */
        label: _propTypes2.default.string,
        /** name property to be passed to the html select element. */
        name: _propTypes2.default.string,
        /** Message to display in any group in items if there are no items in it,
	  including if there is one item that has been selected. */
        noMatchesFound: _propTypes2.default.string,
        /** Handler to be called when the filtered items changes. */
        onFilterChange: _propTypes2.default.func,
        /** Handler to be called when an item is selected. Called with an object that
	  has the item selected as a property on the object. */
        onSelected: _propTypes2.default.func,
        /** Handler called when the select is opened or closed. Called with an object
	  that has both the event, and the new isOpen state. */
        onOpenChange: _propTypes2.default.func,
        /** Text to be shown within the select when no item is selected. */
        placeholder: _propTypes2.default.string,
        /** Where the select dropdown should be displayed relative to the field position. */
        position: _propTypes2.default.string,
        /** Sets whether the field should be constrained to the width of its trigger */
        shouldFitContainer: _propTypes2.default.bool,
        /** Sets whether the field will become focused. */
        shouldFocus: _propTypes2.default.bool,
        /** Sets whether the droplist should flip its position when there is not enough space. */
        shouldFlip: _propTypes2.default.bool,
        /** Set the max height of the dropdown list in pixels. */
        maxHeight: _propTypes2.default.number
    }, AkSingleSelect.defaultProps = {
        appearance: appearances.default,
        droplistShouldFitContainer: !0,
        isRequired: !1,
        items: [],
        label: "",
        onFilterChange: function() {},
        onOpenChange: function() {},
        onSelected: function() {},
        placeholder: "",
        position: "bottom left",
        shouldFocus: !1,
        shouldFlip: !0
    }, exports.default = AkSingleSelect;
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("prop-types");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 8 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(9), _extends3 = _interopRequireDefault(_extends2), _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(4), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(5), _inherits3 = _interopRequireDefault(_inherits2), _propTypes = __webpack_require__(6), _propTypes2 = _interopRequireDefault(_propTypes), _react = __webpack_require__(7), _react2 = _interopRequireDefault(_react), _droplist = __webpack_require__(10), _droplist2 = _interopRequireDefault(_droplist), _fieldBase = __webpack_require__(11), _fieldBase2 = _interopRequireDefault(_fieldBase), _expand = __webpack_require__(12), _expand2 = _interopRequireDefault(_expand), _spinner = __webpack_require__(13), _spinner2 = _interopRequireDefault(_spinner), _appearances = __webpack_require__(14), _Autocomplete = __webpack_require__(15), _Content = __webpack_require__(20), _Content2 = _interopRequireDefault(_Content), _DummyItem = __webpack_require__(21), _DummyItem2 = _interopRequireDefault(_DummyItem), _DummyGroup = __webpack_require__(22), _DummyGroup2 = _interopRequireDefault(_DummyGroup), _ElemBefore = __webpack_require__(23), _ElemBefore2 = _interopRequireDefault(_ElemBefore), _Expand = __webpack_require__(24), _Expand2 = _interopRequireDefault(_Expand), _InitialLoading = __webpack_require__(25), _InitialLoading2 = _interopRequireDefault(_InitialLoading), _NothingWasFound = __webpack_require__(27), _NothingWasFound2 = _interopRequireDefault(_NothingWasFound), _Placeholder = __webpack_require__(29), _Placeholder2 = _interopRequireDefault(_Placeholder), _StatelessSelectWrapper = __webpack_require__(30), _StatelessSelectWrapper2 = _interopRequireDefault(_StatelessSelectWrapper), _Trigger = __webpack_require__(31), _Trigger2 = _interopRequireDefault(_Trigger), appearances = {
        values: [ "default", "subtle" ],
        default: "default"
    }, itemShape = _DummyItem2.default.propTypes, groupShape = _DummyGroup2.default.propTypes, isMatched = function(item, matchingValue) {
        var filterValues = item.filterValues;
        return filterValues && filterValues.length > 0 ? filterValues.some(function(value) {
            return value.toLowerCase().indexOf(matchingValue) > -1;
        }) : item.content.toLowerCase().indexOf(matchingValue) > -1;
    }, StatelessSelect = function(_PureComponent) {
        function StatelessSelect() {
            var _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, StatelessSelect);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, _PureComponent.call.apply(_PureComponent, [ this ].concat(args))), 
            _this.state = {}, _this.componentDidMount = function() {
                (_this.props.isOpen || _this.props.shouldFocus) && _this.focus(), !_this.props.droplistShouldFitContainer && _this.droplistNode && _this.setDroplistMinWidth();
            }, _this.componentDidUpdate = function(prevProps) {
                !prevProps.shouldFocus && _this.props.shouldFocus && _this.focus(), !_this.props.droplistShouldFitContainer && _this.droplistNode && _this.setDroplistMinWidth();
            }, _this.onOpenChange = function(attrs) {
                _this.props.onOpenChange(attrs), _this.setState({
                    focusedItemIndex: void 0
                }), attrs.isOpen && _this.focus();
            }, _this.getNextFocusable = function(indexItem, length) {
                var currentItem = indexItem;
                return void 0 === currentItem ? currentItem = 0 : currentItem < length ? currentItem++ : currentItem = 0, 
                currentItem;
            }, _this.getPrevFocusable = function(indexItem, length) {
                var currentItem = indexItem;
                return currentItem > 0 ? currentItem-- : currentItem = length, currentItem;
            }, _this.getAllItems = function(groups) {
                var allItems = [];
                return groups.forEach(function(val) {
                    allItems = allItems.concat(val.items);
                }), allItems;
            }, _this.getAllVisibleItems = function(groups) {
                return _this.filterItems(_this.getAllItems(groups));
            }, _this.getNextNativeSearchItem = function(items, key, currentIndex, isSecondStep) {
                var res = items.find(function(item, index) {
                    var content = item.content && item.content.toLowerCase();
                    return !(index <= currentIndex) && (content && 0 === content.indexOf(key.toLowerCase()));
                });
                return res || isSecondStep || (res = _this.getNextNativeSearchItem(items, key, -1, !0)), 
                res;
            }, _this.setDroplistMinWidth = function() {
                var width = _this.triggerNode.getBoundingClientRect().width;
                _this.setState({
                    droplistWidth: width
                });
            }, _this.getItemTrueIndex = function(itemIndex) {
                var groupIndex = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return itemIndex + _this.props.items.filter(function(group, thisGroupIndex) {
                    return thisGroupIndex < groupIndex;
                }).reduce(function(totalItems, group) {
                    return totalItems + group.items.length;
                }, 0);
            }, _this.focus = function() {
                _this.inputNode ? _this.inputNode.focus() : _this.triggerNode.focus();
            }, _this.clearNativeSearch = function() {
                _this.nativeSearchKey = "", _this.nativeSearchCounter = void 0;
            }, _this.filterItems = function(items) {
                var value = _this.props.filterValue, trimmedValue = value && value.toLowerCase().trim(), selectedItem = _this.props.selectedItem, unselectedItems = items.filter(function(item) {
                    return selectedItem.value !== item.value;
                }), selectedItemContent = selectedItem.content && selectedItem.content.toLowerCase();
                return trimmedValue && trimmedValue !== selectedItemContent ? unselectedItems.filter(function(item) {
                    return isMatched(item, trimmedValue);
                }) : unselectedItems;
            }, _this.scrollToFocused = function(index) {
                var scrollable = _this.containerNode.querySelector('[data-role="droplistContent"]'), item = void 0;
                scrollable && void 0 !== index && (item = scrollable.querySelectorAll('[data-role="droplistItem"]')[index]), 
                item && scrollable && (scrollable.scrollTop = item.offsetTop - scrollable.clientHeight + item.clientHeight);
            }, _this.focusNextItem = function() {
                var filteredItems = _this.getAllVisibleItems(_this.props.items), length = filteredItems.length - 1, index = _this.getNextFocusable(_this.state.focusedItemIndex, length);
                _this.setState({
                    focusedItemIndex: index
                }), _this.scrollToFocused(index);
            }, _this.focusPreviousItem = function() {
                var filteredItems = _this.getAllVisibleItems(_this.props.items), length = filteredItems.length - 1, index = _this.getPrevFocusable(_this.state.focusedItemIndex, length);
                _this.setState({
                    focusedItemIndex: index
                }), _this.scrollToFocused(index);
            }, _this.focusItem = function(item) {
                var filteredItems = _this.getAllVisibleItems(_this.props.items), index = filteredItems.indexOf(item);
                _this.setState({
                    focusedItemIndex: index
                }), _this.scrollToFocused(index);
            }, _this.handleNativeSearch = function(event) {
                var _this$props = _this.props, selectedItem = _this$props.selectedItem, items = _this$props.items, eventKey = event.key, _this2 = _this, nativeSearchKey = _this2.nativeSearchKey, allItems = _this.getAllItems(items);
                _this.nativeSearchCounter ? nativeSearchKey += eventKey : nativeSearchKey = eventKey;
                var current = void 0 !== _this.state.focusedItemIndex ? _this.state.focusedItemIndex : allItems.indexOf(selectedItem), allItemsWithoutSelected = selectedItem && selectedItem.value ? allItems.filter(function(item) {
                    return item.value !== selectedItem.value;
                }) : allItems;
                if (_this.props.isOpen) {
                    var _matchingItem = _this.getNextNativeSearchItem(allItemsWithoutSelected, nativeSearchKey, current);
                    _this.focusItem(_matchingItem);
                } else {
                    var matchingItem = _this.getNextNativeSearchItem(allItems, nativeSearchKey, current);
                    _this.handleItemSelect(matchingItem, {
                        event: event
                    });
                }
                clearTimeout(_this.nativeSearchCounter), _this.nativeSearchCounter = setTimeout(_this.clearNativeSearch, 200), 
                _this.previousKey = eventKey, _this.nativeSearchKey = nativeSearchKey;
            }, _this.handleKeyboardInteractions = function(event) {
                var isSelectOpen = _this.props.isOpen;
                switch (event.key) {
                  case "ArrowDown":
                    event.preventDefault(), isSelectOpen || _this.onOpenChange({
                        event: event,
                        isOpen: !0
                    }), _this.focusNextItem();
                    break;

                  case "ArrowUp":
                    event.preventDefault(), isSelectOpen && _this.focusPreviousItem();
                    break;

                  case "Enter":
                    isSelectOpen && (event.preventDefault(), void 0 !== _this.state.focusedItemIndex && _this.handleItemSelect(_this.getAllVisibleItems(_this.props.items)[_this.state.focusedItemIndex], {
                        event: event
                    }));
                    break;

                  default:
                    _this.props.hasAutocomplete || _this.handleNativeSearch(event);
                }
            }, _this.handleInputOnChange = function(event) {
                var value = event.target.value;
                value !== _this.props.filterValue && (_this.props.onFilterChange(value), _this.onOpenChange({
                    event: event,
                    isOpen: !0
                }));
            }, _this.handleTriggerClick = function(event) {
                _this.props.isDisabled || _this.onOpenChange({
                    event: event,
                    isOpen: !_this.props.isOpen
                });
            }, _this.handleItemSelect = function(item, attrs) {
                item && !item.isDisabled && (_this.props.onOpenChange({
                    isOpen: !1,
                    event: attrs.event
                }), _this.props.onSelected(item), _this.props.onFilterChange(item.content), _this.setState({
                    focusedItemIndex: void 0
                }));
            }, _this.renderItems = function(items) {
                var groupIndex = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, filteredItems = _this.filterItems(items);
                return filteredItems.length ? filteredItems.map(function(item, itemIndex) {
                    return _react2.default.createElement(_droplist.Item, (0, _extends3.default)({}, item, {
                        isFocused: _this.getItemTrueIndex(itemIndex, groupIndex) === _this.state.focusedItemIndex,
                        key: itemIndex,
                        onActivate: function(attrs) {
                            _this.handleItemSelect(item, attrs);
                        },
                        type: "option"
                    }), item.content);
                }) : _react2.default.createElement(_NothingWasFound2.default, {
                    noMatchesFound: _this.props.noMatchesFound
                });
            }, _this.renderGroups = function(groups) {
                return _this.props.isLoading ? _react2.default.createElement(_InitialLoading2.default, null, _this.props.loadingMessage) : groups.map(function(group, groupIndex) {
                    return _react2.default.createElement(_droplist.Group, {
                        heading: group.heading,
                        key: groupIndex
                    }, _this.renderItems(group.items, groupIndex));
                });
            }, _this.renderOptions = function(items) {
                return items.map(function(item, itemIndex) {
                    return _react2.default.createElement("option", {
                        disabled: item.isDisabled,
                        key: itemIndex,
                        value: item.value
                    }, item.content);
                });
            }, _this.renderOptGroups = function(groups) {
                return groups.map(function(group, groupIndex) {
                    return _react2.default.createElement("optgroup", {
                        label: group.heading,
                        key: groupIndex
                    }, _this.renderOptions(group.items));
                });
            }, _this.renderSelect = function() {
                return _react2.default.createElement("select", {
                    disabled: _this.props.isDisabled,
                    id: _this.props.id,
                    name: _this.props.name,
                    readOnly: !0,
                    required: _this.props.isRequired,
                    style: {
                        display: "none"
                    },
                    value: _this.props.selectedItem.value
                }, _react2.default.createElement("option", {
                    value: ""
                }), _this.renderOptGroups(_this.props.items));
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(StatelessSelect, _PureComponent), StatelessSelect.prototype.render = function() {
            var _this3 = this, _props = this.props, appearance = _props.appearance, droplistShouldFitContainer = _props.droplistShouldFitContainer, filterValue = _props.filterValue, hasAutocomplete = _props.hasAutocomplete, id = _props.id, invalidMessage = _props.invalidMessage, isDisabled = _props.isDisabled, isFirstChild = _props.isFirstChild, isInvalid = _props.isInvalid, isLoading = _props.isLoading, isOpen = _props.isOpen, isRequired = _props.isRequired, items = _props.items, label = _props.label, placeholder = _props.placeholder, position = _props.position, selectedItem = _props.selectedItem, shouldFitContainer = _props.shouldFitContainer, shouldFlip = _props.shouldFlip, maxHeight = _props.maxHeight;
            // disabled because all of the accessibility is handled manually
            /* eslint-disable jsx-a11y/no-static-element-interactions */
            return _react2.default.createElement(_StatelessSelectWrapper2.default, {
                onKeyDown: this.handleKeyboardInteractions,
                innerRef: function(ref) {
                    _this3.containerNode = ref;
                },
                shouldFitContainer: shouldFitContainer
            }, this.renderSelect(), label ? _react2.default.createElement(_fieldBase.Label, {
                htmlFor: id,
                isFirstChild: isFirstChild,
                isRequired: isRequired,
                label: label
            }) : null, _react2.default.createElement(_droplist2.default, {
                isKeyboardInteractionDisabled: !0,
                isOpen: isOpen,
                isTriggerDisabled: !0,
                isTriggerNotTabbable: !0,
                onOpenChange: this.onOpenChange,
                position: position,
                shouldFitContainer: droplistShouldFitContainer,
                shouldFlip: shouldFlip,
                maxHeight: maxHeight,
                trigger: _react2.default.createElement(_fieldBase2.default, {
                    appearance: (0, _appearances.mapAppearanceToFieldBase)([ appearance ]),
                    isDisabled: isDisabled,
                    isFitContainerWidthEnabled: !0,
                    isInvalid: isInvalid,
                    invalidMessage: invalidMessage,
                    isPaddingDisabled: !0
                }, _react2.default.createElement(_Trigger2.default, {
                    onClick: this.handleTriggerClick,
                    tabIndex: isDisabled || hasAutocomplete ? null : "0",
                    innerRef: function(ref) {
                        return _this3.triggerNode = ref;
                    }
                }, !hasAutocomplete || isDisabled ? _react2.default.createElement(_Content2.default, null, selectedItem.elemBefore ? _react2.default.createElement(_ElemBefore2.default, null, selectedItem.elemBefore) : null, selectedItem.content ? _react2.default.createElement("span", null, selectedItem.content) : _react2.default.createElement(_Placeholder2.default, null, placeholder)) : _react2.default.createElement(_Autocomplete.AutocompleteWrapper, null, _react2.default.createElement(_Autocomplete.AutocompleteInput, {
                    onChange: this.handleInputOnChange,
                    placeholder: placeholder,
                    innerRef: function(ref) {
                        return _this3.inputNode = ref;
                    },
                    type: "text",
                    value: filterValue,
                    disabled: isDisabled
                })), _react2.default.createElement(_Expand2.default, null, isOpen && isLoading ? _react2.default.createElement(_spinner2.default, null) : _react2.default.createElement(_expand2.default, {
                    label: ""
                }))))
            }, _react2.default.createElement("div", {
                ref: function(_ref) {
                    return _this3.droplistNode = _ref;
                },
                style: {
                    minWidth: this.state.droplistWidth
                }
            }, this.renderGroups(items))));
        }, StatelessSelect;
    }(_react.PureComponent);
    StatelessSelect.propTypes = {
        /** Subtle items do not have a background color. */
        appearance: _propTypes2.default.oneOf(appearances.values),
        /** Sets whether the dropdown should be constrained to the width of its trigger */
        droplistShouldFitContainer: _propTypes2.default.bool,
        /** Value to be used when filtering the items. Compared against 'content'. */
        filterValue: _propTypes2.default.string,
        /** Sets whether the field should be selectable. If it is, the field will be
	  a text box, which will filter the items. */
        hasAutocomplete: _propTypes2.default.bool,
        /** id property to be passed down to the html select component. */
        id: _propTypes2.default.string,
        /** message to show on the dialog when isInvalid is true */
        invalidMessage: _propTypes2.default.node,
        /** Sets whether the select is selectable. Changes hover state. */
        isDisabled: _propTypes2.default.bool,
        /** controls the top margin of the label component rendered. */
        isFirstChild: _propTypes2.default.bool,
        /** Sets whether the Select dropdown is open. */
        isOpen: _propTypes2.default.bool,
        /** Sets whether form including select can be submitted without an option
	  being made. */
        isRequired: _propTypes2.default.bool,
        /** Set whether there is an error with the selection. Sets an orange border
	  and shows the warning icon. */
        isInvalid: _propTypes2.default.bool,
        /** Sets whether the field is loading data. The same property is used
	   * for either initial fetch (when no options are available) as well for
	   * subsequent loading of more options. The component reacts accordingly
	   * based on the `items` provided.
	   */
        isLoading: _propTypes2.default.bool,
        /** An array of objects, each one of which must have an array of items, and
	  may have a heading. All items should have content and value properties, with
	  content being the displayed text, and can optionally have a list of filterValues. */
        items: _propTypes2.default.arrayOf(_propTypes2.default.shape(groupShape)),
        /** Label to be displayed above select. */
        label: _propTypes2.default.string,
        /** Message to be displayed when the component is set to its loading state.
	  The message might be displayed differently depending on whether or not
	  there are items already being rendered. */
        loadingMessage: _propTypes2.default.string,
        /** name property to be passed to the html select element. */
        name: _propTypes2.default.string,
        /** Message to display in any group in items if there are no items in it,
	  including if there is one item that has been selected. */
        noMatchesFound: _propTypes2.default.string,
        /** Handler called when a selection is made, with the item chosen. */
        onSelected: _propTypes2.default.func,
        /** Handler to be called when the filtered items changes. */
        onFilterChange: _propTypes2.default.func,
        /** Handler called when the select is opened or closed. Called with an object
	  that has both the event, and the new isOpen state. */
        onOpenChange: _propTypes2.default.func,
        /** Text to be shown within the select when no item is selected. */
        placeholder: _propTypes2.default.string,
        /** Where the select dropdown should be displayed relative to the field position. */
        position: _propTypes2.default.string,
        /** Sets whether the field will become focused. */
        shouldFocus: _propTypes2.default.bool,
        /** The selected item data */
        selectedItem: _propTypes2.default.shape(itemShape),
        /** Sets whether the field should be constrained to the width of its trigger */
        shouldFitContainer: _propTypes2.default.bool,
        /** Sets whether the droplist should flip its position when there is not enough space. */
        shouldFlip: _propTypes2.default.bool,
        /** Set the max height of the dropdown list in pixels. */
        maxHeight: _propTypes2.default.number
    }, StatelessSelect.defaultProps = {
        appearance: appearances.default,
        droplistShouldFitContainer: !0,
        filterValue: "",
        hasAutocomplete: !1,
        isLoading: !1,
        isOpen: !1,
        isRequired: !1,
        items: [],
        label: "",
        loadingMessage: "Receiving information",
        noMatchesFound: "No matches found",
        onFilterChange: function() {},
        onSelected: function() {},
        onOpenChange: function() {},
        placeholder: "",
        position: "bottom left",
        shouldFocus: !1,
        selectedItem: {},
        shouldFlip: !0
    }, exports.default = StatelessSelect;
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/extends");
}, /* 10 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/droplist");
}, /* 11 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/field-base");
}, /* 12 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/icon/glyph/expand");
}, /* 13 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/spinner");
}, /* 14 */
/***/
function(module, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    // =============================================================
    // NOTE: Duplicated in ../index and ../stateless until docgen can follow imports.
    // -------------------------------------------------------------
    // DO NOT update values here without updating the other.
    // =============================================================
    var appearancesMap = (exports.appearances = {
        values: [ "default", "subtle" ],
        default: "default"
    }, {
        default: "standard",
        subtle: "subtle"
    });
    exports.mapAppearanceToFieldBase = function(appearance) {
        return appearancesMap[appearance];
    };
}, /* 15 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.AutocompleteWrapper = exports.AutocompleteInput = void 0;
    var _taggedTemplateLiteral2 = __webpack_require__(16), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  flex: 1 1 auto;\n  white-space: nowrap;\n  padding: 0 ", "px;\n" ], [ "\n  flex: 1 1 auto;\n  white-space: nowrap;\n  padding: 0 ", "px;\n" ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  background: none;\n  border: 0;\n  color: ", ";\n  font-size: 14px;\n  margin: 0;\n  min-height: ", "px;\n  outline: 0;\n  padding: 0;\n  width: 100%;\n\n  ", "\n" ], [ "\n  background: none;\n  border: 0;\n  color: ", ";\n  font-size: 14px;\n  margin: 0;\n  min-height: ", "px;\n  outline: 0;\n  padding: 0;\n  width: 100%;\n\n  ", "\n" ]), _styledComponents = __webpack_require__(17), _styledComponents2 = _interopRequireDefault(_styledComponents), _utilSharedStyles = __webpack_require__(18), _placeholderStyles = __webpack_require__(19), _placeholderStyles2 = _interopRequireDefault(_placeholderStyles), AutocompleteWrapper = _styledComponents2.default.div(_templateObject, _utilSharedStyles.akGridSizeUnitless);
    AutocompleteWrapper.displayName = "SingleSelectAutocompleteWrapper";
    var AutocompleteInput = _styledComponents2.default.input(_templateObject2, _utilSharedStyles.akColorN800, 4.5 * _utilSharedStyles.akGridSizeUnitless, _utilSharedStyles.akHelperMixins.placeholder(_placeholderStyles2.default));
    AutocompleteInput.displayName = "SingleSelectAutocompleteInput", exports.default = AutocompleteInput, 
    exports.AutocompleteInput = AutocompleteInput, exports.AutocompleteWrapper = AutocompleteWrapper;
}, /* 16 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/taggedTemplateLiteral");
}, /* 17 */
/***/
function(module, exports) {
    module.exports = require("styled-components");
}, /* 18 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/util-shared-styles");
}, /* 19 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _taggedTemplateLiteral2 = __webpack_require__(16), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  color: ", ";\n  font-size: 14px;\n" ], [ "\n  color: ", ";\n  font-size: 14px;\n" ]), _styledComponents = __webpack_require__(17), _utilSharedStyles = __webpack_require__(18), placeholderStyles = (0, 
    _styledComponents.css)(_templateObject, _utilSharedStyles.akColorN200);
    exports.default = placeholderStyles;
}, /* 20 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _taggedTemplateLiteral2 = __webpack_require__(16), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  align-items: center;\n  display: flex;\n  flex: 1 1 auto;\n  margin: ", "px 6px;\n  white-space: nowrap;\n" ], [ "\n  align-items: center;\n  display: flex;\n  flex: 1 1 auto;\n  margin: ", "px 6px;\n  white-space: nowrap;\n" ]), _styledComponents = __webpack_require__(17), _styledComponents2 = _interopRequireDefault(_styledComponents), _utilSharedStyles = __webpack_require__(18), Content = _styledComponents2.default.div(_templateObject, _utilSharedStyles.akGridSizeUnitless);
    Content.displayName = "SingleSelectContent", exports.default = Content;
}, /* 21 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(4), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(5), _inherits3 = _interopRequireDefault(_inherits2), _propTypes = __webpack_require__(6), _propTypes2 = _interopRequireDefault(_propTypes), _react = __webpack_require__(7), DummyItem = function(_PureComponent) {
        function DummyItem() {
            return (0, _classCallCheck3.default)(this, DummyItem), (0, _possibleConstructorReturn3.default)(this, _PureComponent.apply(this, arguments));
        }
        return (0, _inherits3.default)(DummyItem, _PureComponent), DummyItem;
    }(_react.PureComponent);
    DummyItem.propTypes = {
        content: _propTypes2.default.node,
        description: _propTypes2.default.string,
        tooltipDescription: _propTypes2.default.string,
        tooltipPosition: _propTypes2.default.oneOf([ "top", "bottom", "left", "right" ]),
        value: _propTypes2.default.oneOfType([ _propTypes2.default.string, _propTypes2.default.number ]),
        filterValues: _propTypes2.default.arrayOf(_propTypes2.default.string),
        isDisabled: _propTypes2.default.bool,
        isSelected: _propTypes2.default.bool,
        elemBefore: _propTypes2.default.node,
        elemAfter: _propTypes2.default.node
    }, DummyItem.defaultProps = {
        isDisabled: !1,
        isSelected: !1
    }, exports.default = DummyItem;
}, /* 22 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(4), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(5), _inherits3 = _interopRequireDefault(_inherits2), _propTypes = __webpack_require__(6), _propTypes2 = _interopRequireDefault(_propTypes), _react = __webpack_require__(7), _DummyItem = __webpack_require__(21), _DummyItem2 = _interopRequireDefault(_DummyItem), DummyGroup = function(_PureComponent) {
        function DummyGroup() {
            return (0, _classCallCheck3.default)(this, DummyGroup), (0, _possibleConstructorReturn3.default)(this, _PureComponent.apply(this, arguments));
        }
        return (0, _inherits3.default)(DummyGroup, _PureComponent), DummyGroup;
    }(_react.PureComponent);
    DummyGroup.propTypes = {
        heading: _propTypes2.default.string,
        items: _propTypes2.default.arrayOf(_propTypes2.default.shape(_DummyItem2.default.propTypes))
    }, exports.default = DummyGroup;
}, /* 23 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _taggedTemplateLiteral2 = __webpack_require__(16), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  display: flex;\n  padding-right: ", "px;\n" ], [ "\n  display: flex;\n  padding-right: ", "px;\n" ]), _styledComponents = __webpack_require__(17), _styledComponents2 = _interopRequireDefault(_styledComponents), _utilSharedStyles = __webpack_require__(18), ElemBefore = _styledComponents2.default.div(_templateObject, _utilSharedStyles.akGridSizeUnitless);
    ElemBefore.displayName = "TriggerElemBefore", exports.default = ElemBefore;
}, /* 24 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _taggedTemplateLiteral2 = __webpack_require__(16), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  align-items: center;\n  display: flex;\n  flex: 0 0 ", "px;\n  justify-content: center;\n  margin: 0px ", "px;\n" ], [ "\n  align-items: center;\n  display: flex;\n  flex: 0 0 ", "px;\n  justify-content: center;\n  margin: 0px ", "px;\n" ]), _styledComponents = __webpack_require__(17), _styledComponents2 = _interopRequireDefault(_styledComponents), _utilSharedStyles = __webpack_require__(18), Expand = _styledComponents2.default.div(_templateObject, 3 * _utilSharedStyles.akGridSizeUnitless, _utilSharedStyles.akGridSizeUnitless);
    Expand.displayName = "SingleSelectExpand", exports.default = Expand;
}, /* 25 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(4), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(5), _inherits3 = _interopRequireDefault(_inherits2), _propTypes = __webpack_require__(6), _propTypes2 = _interopRequireDefault(_propTypes), _react = __webpack_require__(7), _react2 = _interopRequireDefault(_react), _InitialLoading = __webpack_require__(26), _InitialLoading2 = _interopRequireDefault(_InitialLoading), InitialLoading = function(_PureComponent) {
        function InitialLoading() {
            return (0, _classCallCheck3.default)(this, InitialLoading), (0, _possibleConstructorReturn3.default)(this, _PureComponent.apply(this, arguments));
        }
        return (0, _inherits3.default)(InitialLoading, _PureComponent), InitialLoading.prototype.render = function() {
            return _react2.default.createElement(_InitialLoading2.default, {
                "aria-live": "polite",
                role: "status"
            }, this.props.children);
        }, InitialLoading;
    }(_react.PureComponent);
    InitialLoading.propTypes = {
        children: _propTypes2.default.node
    }, exports.default = InitialLoading;
}, /* 26 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _taggedTemplateLiteral2 = __webpack_require__(16), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  padding: 6px ", "px;\n" ], [ "\n  padding: 6px ", "px;\n" ]), _styledComponents = __webpack_require__(17), _styledComponents2 = _interopRequireDefault(_styledComponents), _utilSharedStyles = __webpack_require__(18), InitialLoadingElement = _styledComponents2.default.div(_templateObject, 3 * _utilSharedStyles.akGridSizeUnitless);
    InitialLoadingElement.displayName = "InitialLoadingElement", exports.default = InitialLoadingElement;
}, /* 27 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(4), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(5), _inherits3 = _interopRequireDefault(_inherits2), _propTypes = __webpack_require__(6), _propTypes2 = _interopRequireDefault(_propTypes), _react = __webpack_require__(7), _react2 = _interopRequireDefault(_react), _NothingWasFound = __webpack_require__(28), _NothingWasFound2 = _interopRequireDefault(_NothingWasFound), NothingWasFound = function(_PureComponent) {
        function NothingWasFound() {
            return (0, _classCallCheck3.default)(this, NothingWasFound), (0, _possibleConstructorReturn3.default)(this, _PureComponent.apply(this, arguments));
        }
        return (0, _inherits3.default)(NothingWasFound, _PureComponent), NothingWasFound.prototype.render = function() {
            return _react2.default.createElement(_NothingWasFound2.default, null, this.props.noMatchesFound);
        }, NothingWasFound;
    }(_react.PureComponent);
    NothingWasFound.propTypes = {
        noMatchesFound: _propTypes2.default.string
    }, exports.default = NothingWasFound;
}, /* 28 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _taggedTemplateLiteral2 = __webpack_require__(16), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  padding: 6px ", "px;\n" ], [ "\n  padding: 6px ", "px;\n" ]), _styledComponents = __webpack_require__(17), _styledComponents2 = _interopRequireDefault(_styledComponents), _utilSharedStyles = __webpack_require__(18), NothingWasFoundElement = _styledComponents2.default.div(_templateObject, 3 * _utilSharedStyles.akGridSizeUnitless);
    NothingWasFoundElement.displayName = "NothingWasFoundElement", exports.default = NothingWasFoundElement;
}, /* 29 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _taggedTemplateLiteral2 = __webpack_require__(16), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n" ], [ "\n  ", "\n" ]), _styledComponents = __webpack_require__(17), _styledComponents2 = _interopRequireDefault(_styledComponents), _placeholderStyles = __webpack_require__(19), _placeholderStyles2 = _interopRequireDefault(_placeholderStyles), Placeholder = _styledComponents2.default.span(_templateObject, _placeholderStyles2.default);
    Placeholder.displayName = "SingleSelectPlaceholder", exports.default = Placeholder;
}, /* 30 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _taggedTemplateLiteral2 = __webpack_require__(16), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  display: ", ";\n" ], [ "\n  display: ", ";\n" ]), _styledComponents = __webpack_require__(17), _styledComponents2 = _interopRequireDefault(_styledComponents), StatelessSelectWrapper = _styledComponents2.default.div(_templateObject, function(props) {
        return props.shouldFitContainer ? "block" : "inline-block";
    });
    StatelessSelectWrapper.displayName = "SingleSelectStatelessSelectWrapper", exports.default = StatelessSelectWrapper;
}, /* 31 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _taggedTemplateLiteral2 = __webpack_require__(16), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  align-items: center;\n  display: flex;\n  min-height: ", "px;\n  outline: none;\n  width: 100%;\n" ], [ "\n  align-items: center;\n  display: flex;\n  min-height: ", "px;\n  outline: none;\n  width: 100%;\n" ]), _styledComponents = __webpack_require__(17), _styledComponents2 = _interopRequireDefault(_styledComponents), _utilSharedStyles = __webpack_require__(18), Trigger = _styledComponents2.default.div(_templateObject, 4.5 * _utilSharedStyles.akGridSizeUnitless);
    Trigger.displayName = "SingleSelectTrigger", exports.default = Trigger;
} ]);


//////////////////
// WEBPACK FOOTER
// ./~/@atlaskit/single-select/dist/bundle-cjs.js
// module id = 361
// module chunks = 0